import React from 'react'
import clsx from 'clsx'
import kebabCase from 'lodash.kebabcase'
import { NumbersSectionProps } from '@/components/organisms/NumbersSection/types'
import { ReactComponent as Line } from '@/assets/icons/wavy_line.svg'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'

export function NumbersSection({ pageContent, instance, ...props }: NumbersSectionProps) {
  const { content } = pageContent?.blok || instance || {}
  const { heading, items } = content || props

  return (
    <section className={clsx('bg-center relative bg-primary-100 overflow-hidden', {})} id={kebabCase(heading)}>
      <Line className="absolute top-0 left-0 z-0 w-full -rotate-3" />
      <Line className="absolute bottom-0 right-0 netbook:-right-1/4 w-full z-0 -rotate-180" />
      <div
        className="flex flex-col px-24 py-48 gap-24 mx-auto
    laptop:px-90 netbook:flex-row netbook:items-center netbook:justify-between netbook:py-64 max-w-screen-desktop *:z-10"
      >
        <div className="flex flex-col gap-40 w-full items-center">
          {heading && (
            <h2 className="text-headingS-mobile netbook:text-headingS font-poppins font-bold text-text-dark-900 text-center">
              {heading}
            </h2>
          )}
          <div className="flex flex-col items-center tablet-lg:flex-row w-full gap-24 tablet-lg:gap-16 justify-between">
            {items &&
              items.length &&
              items.map((item) => (
                <>
                  <div key={item.title} className={clsx('text-center w-full tablet-lg:max-w-250')}>
                    <p className="text-headingL-mobile tablet-lg:text-headingL font-poppins text-text-brand-darker mb-12">
                      {item.value}
                    </p>
                    <Paragraph className="text-bodyS font-sans text-text-dark-900">{item.title}</Paragraph>
                  </div>
                  <div className=" w-144 h-1 tablet-lg:h-90 tablet-lg:w-1 content-[''] bg-primary-300 last:hidden my-auto" />
                </>
              ))}
          </div>
        </div>
      </div>
    </section>
  )
}
